import script from "./Assistant.vue?vue&type=script&setup=true&lang=ts"
export * from "./Assistant.vue?vue&type=script&setup=true&lang=ts"

import "./Assistant.vue?vue&type=style&index=0&id=f183160c&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f183160c"]])

export default __exports__